/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".rpt-tp-dnp[_ngcontent-%COMP%]{color:#e00000}.rpt-tp-purchase[_ngcontent-%COMP%]{color:#b55e00}.rpt-tp-purchase-aq[_ngcontent-%COMP%]{color:#5d8200}.buttons-column[_ngcontent-%COMP%]{min-width:170px}"];
export { styles as styles };
